import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Children } from 'react';
import PropTypes from 'prop-types';
import Theme, { ThemeShape } from "./Theme";
import normalizeStyle from "./StyleNormalizer/normalizeStyle";

var StyleProvider = function (_React$Component) {
  _inherits(StyleProvider, _React$Component);

  function StyleProvider(props, context) {
    var _this;

    _classCallCheck(this, StyleProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StyleProvider).call(this, props, context));
    _this.state = {
      theme: _this.createTheme(props)
    };
    return _this;
  }

  _createClass(StyleProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        theme: this.state.theme
      };
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.style !== this.props.style) {
        this.setState({
          theme: this.createTheme(nextProps)
        });
      }
    }
  }, {
    key: "createTheme",
    value: function createTheme(props) {
      return new Theme(props.style);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return Children.only(children);
    }
  }]);

  return StyleProvider;
}(React.Component);

StyleProvider.propTypes = {
  children: PropTypes.element.isRequired,
  style: PropTypes.object
};
StyleProvider.defaultProps = {
  style: {}
};
StyleProvider.childContextTypes = {
  theme: ThemeShape.isRequired
};
export { StyleProvider as default };